var _circle, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _path, _path2, _g29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOfficeFinish(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 329,
    height: 329,
    viewBox: "0 0 329 329",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_285",
    "data-name": "Group 285",
    transform: "translate(-668 -494)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 164.5,
    cy: 164.5,
    r: 164.5,
    transform: "translate(668 494)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_467",
    "data-name": "Group 467",
    transform: "translate(643.733 518.275)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chair"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_275",
    "data-name": "Group 275"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_274",
    "data-name": "Group 274"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M259.16,95.483H194.185a3.614,3.614,0,0,0-3.6,3.6V204.11a3.614,3.614,0,0,0,3.6,3.6H259.16a3.615,3.615,0,0,0,3.6-3.6V99.087A3.615,3.615,0,0,0,259.16,95.483Z",
    fill: "#f6f7f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_277",
    "data-name": "Group 277"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_276",
    "data-name": "Group 276"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M194.185,95.483a3.614,3.614,0,0,0-3.6,3.6V204.11a3.614,3.614,0,0,0,3.6,3.6H259.16a3.615,3.615,0,0,0,3.6-3.6V193.727",
    fill: "#f6f7f7",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M262.764,175.132V99.087a3.615,3.615,0,0,0-3.6-3.6",
    fill: "#f6f7f7",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_279",
    "data-name": "Group 279"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_278",
    "data-name": "Group 278"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_82",
    "data-name": "Rectangle 82",
    width: 72.184,
    height: 16.791,
    rx: 7.42,
    transform: "translate(190.581 193.267)",
    fill: "#f6f7f7",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_280",
    "data-name": "Group 280"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 26.074,
    cy: 3.063,
    rx: 26.074,
    ry: 3.063,
    transform: "translate(199.709 289.568)",
    fill: "#f6f7f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_283",
    "data-name": "Group 283"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_282",
    "data-name": "Group 282"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M219.014,290.794V215.055c0-2.149,3.046-3.907,6.769-3.907h0c3.723,0,6.769,1.758,6.769,3.907v75.739",
    fill: "#f6f7f7",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_285-2",
    "data-name": "Group 285"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_284",
    "data-name": "Group 284"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    d: "M254.744,210.058c0,4.569-12.8,8.274-28.581,8.274s-28.581-3.705-28.581-8.274Z",
    fill: "#f6f7f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_286",
    "data-name": "Group 286"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M188.6,195.971c-.008.07-.016.132-.024.2l-.038-.015Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_287",
    "data-name": "Group 287"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    d: "M226.672,202.015v.008h-.023v-.008c0-.015.008-.054.016-.123C226.665,201.961,226.672,202,226.672,202.015Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    d: "M226.844,202.2H226.5l-.024-.185.016-.137.156.008v-.03l0,.031.183.009c0,.039,0,.066.005.082Z",
    fill: "#161616"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_288",
    "data-name": "Group 288"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M226.672,202.015v.008h-.023v-.008c0-.015.008-.054.016-.123C226.665,201.961,226.672,202,226.672,202.015Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M226.844,202.2H226.5l-.024-.185.016-.137.156.008v-.03l0,.031.183.009c0,.039,0,.066.005.082Z",
    fill: "#161616"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_289",
    "data-name": "Group 289"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M226.672,202.015v.008h-.023v-.008c0-.015.008-.054.016-.123C226.665,201.961,226.672,202,226.672,202.015Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M226.844,202.2H226.5l-.024-.185.016-.137.156.008v-.03l0,.031.183.009c0,.039,0,.066.005.082Z",
    fill: "#161616"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Model_2",
    "data-name": "Model 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_290",
    "data-name": "Group 290"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M222.936,277.246l-9.5,3.666-3.32-21.081,9.865-1.554Z",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_291",
    "data-name": "Group 291"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_83",
    "data-name": "Rectangle 83",
    width: 20.172,
    height: 9.77,
    transform: "translate(230.348 277.96) rotate(-77.699)",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_293",
    "data-name": "Group 293"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_292",
    "data-name": "Group 292"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M264.763,198.256c-1.736,16.811-13.932,60.56-20.446,74.778l-16.309-3.651c1.566-9.455,6.776-40.561,10.914-60.838a3.627,3.627,0,0,0-2.764-4.222.027.027,0,0,0-.023-.008l-9.463-2.292v-.008c0-.015-.007-.054-.007-.123-.008.069-.016.108-.016.123v.008l-9.463,2.292a3.641,3.641,0,0,0-2.794,4.23c4.153,20.315,8.789,50.566,10.341,59.944l-15.847,3.265c-6.56-14.31-18.6-56.725-20.328-73.5a11.141,11.141,0,0,1,.015-2.084c.008-.069.016-.131.024-.2a21.9,21.9,0,0,1,2.632-8.373,6.975,6.975,0,0,0,.615-1.344l5.907-17.668,52.625,2.053,5.457,10.474a13.17,13.17,0,0,1,1.6,1.428c.918.965,1.868,1.907,2.863,2.794C263.444,188.137,265.087,195.084,264.763,198.256Z",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_294",
    "data-name": "Group 294"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M185.826,27.919a2.506,2.506,0,0,0,.316-2.177,3.072,3.072,0,0,1-.3-.563c-.193-.648.332-1.567.533-2.169.849-2.439,1.682-4.886,2.524-7.332l.293-.865a1.119,1.119,0,0,1,2.115.733l.146-.424.024-.054a1.583,1.583,0,0,1,2.994,1.026l.07-.193a1.587,1.587,0,0,1,3,1.027l-.131.363a1.591,1.591,0,0,1,2.015-.973,1.639,1.639,0,0,1,.972,2.061l-.386,1.111L199.4,21.3a2.085,2.085,0,0,0,1.466,1.852,8.3,8.3,0,0,0,1.876.409,4.581,4.581,0,0,1,2.231.772,2.442,2.442,0,0,1,.995,2.2,1.363,1.363,0,0,1-.308.764,1.127,1.127,0,0,1-1.158.247,6.464,6.464,0,0,1-1.065-.571,3.044,3.044,0,0,0-1.66-.425,6.316,6.316,0,0,0-3.118,1.552,15.9,15.9,0,0,1-1.706,1.088,1.355,1.355,0,0,1-.679.162c-.093,0-.5-.031-.54.085-.008.015-.232.671-.5,1.466l-1.343,2.555c-.139.348-.286.734-.448,1.143-3,7.788-9.6,25.648-9.092,30.187.656,5.851,7.9,21.2,7.9,21.2l-15.731,5.233S166.738,68.58,170.026,61.3c2.547-5.627,10.6-22.523,14.132-29.886.556-1.166,1.109-2.333,1.668-3.5",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_295",
    "data-name": "Group 295"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M269.314,92.234l-15.466-5.973s7.96-14.992,8.888-20.808c.721-4.509-5.039-22.656-7.658-30.582-.062-.185-.124-.364-.185-.543-.076-.213-.145-.419-.214-.618L253.463,31.1c-.234-.8-.426-1.471-.433-1.491-.035-.117-.447-.1-.536-.11a1.347,1.347,0,0,1-.674-.193,15.8,15.8,0,0,1-1.65-1.168,6.281,6.281,0,0,0-3.045-1.691,3.019,3.019,0,0,0-1.677.343,7.226,7.226,0,0,1-1.086.523,1.139,1.139,0,0,1-1.148-.3,1.428,1.428,0,0,1-.275-.776,2.459,2.459,0,0,1,1.1-2.152,4.545,4.545,0,0,1,2.268-.667,8.133,8.133,0,0,0,1.89-.323,2.082,2.082,0,0,0,1.554-1.78l-.536-1.835-.33-1.128a1.637,1.637,0,0,1,1.065-2.014,1.594,1.594,0,0,1,1.966,1.072l-.11-.371a1.586,1.586,0,0,1,3.045-.886l.062.2a1.582,1.582,0,0,1,3.038-.887l.021.055.131.433a1.118,1.118,0,0,1,2.144-.632l.255.873q1.081,3.732,2.172,7.444c.172.612.653,1.554.433,2.193a3.194,3.194,0,0,1-.33.55,2.388,2.388,0,0,0,.082,1.98c.028.075.055.151.083.22l.048-.014s.3.715.818,1.945c.2.475.426,1.018.687,1.629,3.176,7.52,10.428,24.781,12.71,30.521C280.141,70.08,269.314,92.234,269.314,92.234Z",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    "data-name": "Group 297"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_296",
    "data-name": "Group 296"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M205.482,100.978a142.555,142.555,0,0,1,34.642-.011,3.459,3.459,0,0,0,3.251-1.369L254.21,84.869l15.919,6.8s-19.181,21.815-19.181,44.6c0,21.351-1.044,36.419-1.044,36.419l-52.287,1.217-.688-24.643a88.745,88.745,0,0,0-6.038-29.911A146.941,146.941,0,0,0,176.058,91.2L192.782,85.5l9.4,13.986A3.463,3.463,0,0,0,205.482,100.978Z",
    fill: "#0555e6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_298",
    "data-name": "Group 298"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M218.171,99.985s-.151,7.35,4.7,7.667,5.319-7.667,5.319-7.667V86.135H218.171Z",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_299",
    "data-name": "Group 299"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M230.376,279.62s-.286,7.676-.482,12.9-2.654,9.277,3.753,10.593,13.329-.268,14.126-3.62-5.254-11.574-5.128-14.951-1.665-4.828-2.779-3.794S230.376,279.62,230.376,279.62Z",
    fill: "#ededed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_300",
    "data-name": "Group 300"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M229.593,300.555c1.053,1.286,2.64,1.541,4.392,1.691,3.723.338,11.909.458,13.788-2.757a3.465,3.465,0,0,1-1.147,2.5C241.8,306.613,229.99,304.863,229.593,300.555Z",
    fill: "#ededed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_301",
    "data-name": "Group 301"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M241.758,287.814a4.069,4.069,0,0,1-7.811,1.351c-.025-.063-.051-.127-.078-.191a78.324,78.324,0,0,1-3.248-9.581c-.576-1.609-1.322-3.81,2.112-5.219s8.344-1.055,8.286.48C240.98,275.679,242.05,281.348,241.758,287.814Z",
    fill: "#ededed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_302",
    "data-name": "Group 302"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M234.564,290.213s.618-9.477-.721-9.915a22.128,22.128,0,0,0-3.467-.678s.332,9.6,1.881,11.271S234.564,290.213,234.564,290.213Z",
    fill: "#ededed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_304",
    "data-name": "Group 304"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_303",
    "data-name": "Group 303"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M242.53,283.626a.386.386,0,0,1-.168.3c-3.97,2.71-9.184-.353-9.4-.485a.387.387,0,1,1,.4-.664c.048.029,5.014,2.94,8.57.51a.386.386,0,0,1,.6.334Z",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_306",
    "data-name": "Group 306"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_305",
    "data-name": "Group 305"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M242.614,287.439a.391.391,0,0,1-.159.3c-2.461,1.788-8.816-.469-9.084-.567a.387.387,0,1,1,.262-.728c1.728.621,6.6,1.954,8.365.669a.389.389,0,0,1,.543.085A.4.4,0,0,1,242.614,287.439Z",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_307",
    "data-name": "Group 307"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M242.769,290.188a.4.4,0,0,1-.124.27c-1.976,1.832-8.785-.037-9.556-.257a.387.387,0,1,1,.212-.744c1.976.563,7.413,1.737,8.817.433a.388.388,0,0,1,.651.3Z",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_309",
    "data-name": "Group 309"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M223.327,278.876s1.46,7.319,2.454,12.3,3.977,8.49-1.965,10.741-12.827,1.8-14.109-1.292,3.253-11.913,2.611-15.133.852-4.889,2.079-4.068S223.327,278.876,223.327,278.876Z",
    fill: "#ededed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_310",
    "data-name": "Group 310"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M227.311,298.837c-.813,1.4-2.295,1.886-3.952,2.3-3.52.9-11.353,2.277-13.652-.516a3.368,3.368,0,0,0,1.485,2.219C216.531,306.534,227.594,303.031,227.311,298.837Z",
    fill: "#ededed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_311",
    "data-name": "Group 311"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M213.674,288.493a3.953,3.953,0,0,0,7.7.09c.014-.064.029-.129.045-.194a75.881,75.881,0,0,0,1.636-9.693c.3-1.632.68-3.859-2.831-4.68s-8.167.276-7.874,1.74C212.547,276.733,212.4,282.336,213.674,288.493Z",
    fill: "#ededed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_312",
    "data-name": "Group 312"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M220.946,289.684s-2.056-8.995-.839-9.622a21.5,21.5,0,0,1,3.22-1.186s1.165,9.263-.064,11.1S220.946,289.684,220.946,289.684Z",
    fill: "#ededed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_314",
    "data-name": "Group 314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_313",
    "data-name": "Group 313"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M212.541,284.6a.378.378,0,0,0,.209.267c4.226,1.987,8.755-1.757,8.946-1.917a.376.376,0,1,0-.484-.575c-.041.035-4.356,3.593-8.142,1.812a.377.377,0,0,0-.5.181A.381.381,0,0,0,212.541,284.6Z",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_316",
    "data-name": "Group 316"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_315",
    "data-name": "Group 315"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    d: "M213.05,288.266a.38.38,0,0,0,.2.262c2.637,1.335,8.384-1.811,8.627-1.947a.376.376,0,1,0-.364-.657c-1.562.862-6.028,2.892-7.921,1.933a.375.375,0,0,0-.54.409Z",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_318",
    "data-name": "Group 318"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_317",
    "data-name": "Group 317"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    d: "M213.071,290.927a.387.387,0,0,0,.16.24c2.178,1.452,8.422-1.393,9.127-1.722a.376.376,0,0,0-.318-.682c-1.808.846-6.842,2.811-8.391,1.777a.377.377,0,0,0-.578.387Z",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_320",
    "data-name": "Group 320"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_319",
    "data-name": "Group 319"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M245.489,273.667l-17.816-4.385a1.107,1.107,0,0,1-.722-1.382l.7-2.843a1.108,1.108,0,0,1,1.281-.889l17.816,4.385a1.107,1.107,0,0,1,.722,1.382l-.7,2.843A1.107,1.107,0,0,1,245.489,273.667Z",
    fill: "#043aaa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_322",
    "data-name": "Group 322"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_321",
    "data-name": "Group 321"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M225.292,269.687l-17.706,3.3a1.131,1.131,0,0,1-1.28-.952l-.536-2.878a1.129,1.129,0,0,1,.852-1.348l17.706-3.3a1.128,1.128,0,0,1,1.279.951l.536,2.878A1.129,1.129,0,0,1,225.292,269.687Z",
    fill: "#043aaa"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    d: "M231.721,80.626a43.4,43.4,0,0,1-.91,8.793,8.316,8.316,0,0,1-3.465,5.187l-.323.219a5.6,5.6,0,0,1-6.19.075h0a8.31,8.31,0,0,1-3.672-5.513,63.6,63.6,0,0,1-.833-8.761s-.715-8.966,7.587-8.792S231.721,80.626,231.721,80.626Z",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M233.51,79.785l0-.005a5,5,0,0,1-1.814,4.034,27,27,0,0,0-.1-3.994v-.855a3.444,3.444,0,0,1-.723-.488c-1.92-1.85-1.769-3.515-1.711-3.867-.582,3.148-3.888,4.064-4.1,4.114,1.285-1.1,1.2-3.516,1.2-3.516-1.459,2.052-5.27,3.969-8.12,4.768l-.039.015a8.463,8.463,0,0,1-1.241.322,21.939,21.939,0,0,0-.063,3.5,4.825,4.825,0,0,1-1.77-3.39,6.55,6.55,0,0,1-4.8-2.641,2.576,2.576,0,0,0,3.36-1.715,4.06,4.06,0,0,1-1.59.191,2.56,2.56,0,0,1-2.424-1.886s.47.483,3.015.015c2.289-.427,4.015-7.076,9.386-7.353a5.5,5.5,0,0,1,4.281,1.3c0-.629-1.454-1.761-1.454-1.761,5.377.735,4.572,4.185,4.572,4.185C235.295,71.21,233.51,79.785,233.51,79.785Z",
    fill: "#8c8c8c"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "imac"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_325",
    "data-name": "Group 325"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_324",
    "data-name": "Group 324"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_323",
    "data-name": "Group 323"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    d: "M263.8,155.437l-54.345,3.351a1.278,1.278,0,0,1-1.355-1.343l2.563-48.267a2.377,2.377,0,0,1,2.384-2.251l53.267.214a2.833,2.833,0,0,1,2.816,2.994l-2.431,42.39A3.1,3.1,0,0,1,263.8,155.437Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_328",
    "data-name": "Group 328"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_327",
    "data-name": "Group 327"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_326",
    "data-name": "Group 326"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    d: "M264.81,155.437l-54.345,3.351a1.278,1.278,0,0,1-1.355-1.343l2.563-48.267a2.377,2.377,0,0,1,2.384-2.251l53.267.214a2.832,2.832,0,0,1,2.816,2.994l-2.431,42.39A3.094,3.094,0,0,1,264.81,155.437Z",
    fill: "#ededed"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_331",
    "data-name": "Group 331"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_330",
    "data-name": "Group 330"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_329",
    "data-name": "Group 329"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    d: "M239.626,133.6s.534.133.867,2.261,3.392,30.326,3.392,30.326a30.173,30.173,0,0,1-1.729,4.057s13.367-.864,14.5-1.064,3.391-.865,2.128-6.185c-.322-1.353-1.064-3.948-1.993-7.066-2.725-9.147-7.052-22.794-7.052-22.794Z",
    fill: "#ededed"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_334",
    "data-name": "Group 334"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_333",
    "data-name": "Group 333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_332",
    "data-name": "Group 332"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M256.789,155.93c-2.725-9.147-7.052-22.794-7.052-22.794",
    fill: "none",
    stroke: "#5e5e5e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_337",
    "data-name": "Group 337"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_336",
    "data-name": "Group 336"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_335",
    "data-name": "Group 335"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M229.914,168.962v.636s11.6.906,12.466.632,2.327-.606,1.662-7.023-3.258-27.2-3.324-27.661a3.691,3.691,0,0,0-.851-2.012l-.111.455a2.523,2.523,0,0,1,.473,1.034c.121.578,2.757,25.331,3.114,30.892a5.05,5.05,0,0,1-.491,2.543c-.252.517-.586.969-.985.969C240.936,169.427,229.914,168.962,229.914,168.962Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_340",
    "data-name": "Group 340"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_339",
    "data-name": "Group 339"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_338",
    "data-name": "Group 338"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8-2",
    "data-name": "Ellipse 8",
    cx: 2.128,
    cy: 2.924,
    rx: 2.128,
    ry: 2.924,
    transform: "translate(248.412 154.126)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Model_1",
    "data-name": "Model 1"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_343",
    "data-name": "Group 343"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_342",
    "data-name": "Group 342"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_341",
    "data-name": "Group 341"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M158.622,69.139l6.161-10.678,7.461,5.339-1.165,9.61-5.646,15.583-10.427-4.666Z",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_347",
    "data-name": "Group 347"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_346",
    "data-name": "Group 346"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_345",
    "data-name": "Group 345"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_344",
    "data-name": "Group 344"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M102.032,161.675s9.634,56.754,9.819,61.564S116.106,278,116.106,278l37.186,1.85s8.14-38.3,7.955-52.911-5.473-68.467-5.473-68.467l-30.039,3.9Z",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_351",
    "data-name": "Group 351"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_350",
    "data-name": "Group 350"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_349",
    "data-name": "Group 349"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_348",
    "data-name": "Group 348"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M158.622,69.139s-31.676-7.118-44.489,29.184-12.1,58.013-12.1,63.352,53.742-3.2,53.742-3.2-3.915-18.514-2.135-25.629,7.83-22.775,7.83-22.775V116l20.287-3.8s6.05-29.185-10.678-38.794C171.078,73.41,160.045,92.629,158.622,69.139Z",
    fill: "#043aaa"
  })))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_355",
    "data-name": "Group 355"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_354",
    "data-name": "Group 354"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_353",
    "data-name": "Group 353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_352",
    "data-name": "Group 352"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M138.992,278.874c.016-.181,1.639-18.287,4.112-38.084,2.469-19.766-4.171-54.209-4.238-54.555",
    fill: "none",
    stroke: "#5e5e5e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_359",
    "data-name": "Group 359"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_358",
    "data-name": "Group 358"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_357",
    "data-name": "Group 357"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_356",
    "data-name": "Group 356"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M132.748,278.137s-1.158,7.908-.59,8.361a18.838,18.838,0,0,1,1.974,2.929l-1.362,3.892-7.831.9-5.932-6.377v-9.172Z",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_363",
    "data-name": "Group 363"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_362",
    "data-name": "Group 362"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_361",
    "data-name": "Group 361"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_360",
    "data-name": "Group 360"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M136.668,279.036v9.969l4.55,6.663.153.269,8.511-.975,1.481-5.07s-1.859-1.517-2.814-2.17c-.1-.067,1.31-.125,1.306-.172-.061-.855-.884-9.054-.064-9.09Z",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    "data-name": "Group 368"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_367",
    "data-name": "Group 367"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_366",
    "data-name": "Group 366"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_365",
    "data-name": "Group 365"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_364",
    "data-name": "Group 364"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M138.8,279.87l15.528.116a1.141,1.141,0,0,0,1.119-1.055l.386-4a1.148,1.148,0,0,0-1.069-1.285l-15.187-.512Z",
    fill: "#043aaa"
  }))))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_373",
    "data-name": "Group 373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_372",
    "data-name": "Group 372"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_371",
    "data-name": "Group 371"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_370",
    "data-name": "Group 370"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_369",
    "data-name": "Group 369"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M141.063,274.552l-.35,4.628a1.259,1.259,0,0,1-.268.7.968.968,0,0,1-.774.38l-24.8-.524a1.088,1.088,0,0,1-.994-1.114l-.189-5.362a1.11,1.11,0,0,1,1.071-1.223l23.726,1.177,1.614.08A1.117,1.117,0,0,1,141.063,274.552Z",
    fill: "#043aaa"
  }))))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_378",
    "data-name": "Group 378"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_377",
    "data-name": "Group 377"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_376",
    "data-name": "Group 376"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_375",
    "data-name": "Group 375"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_374",
    "data-name": "Group 374"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M138.484,273.21l1.614.08a1.117,1.117,0,0,1,.965,1.262l-.35,4.628a1.259,1.259,0,0,1-.268.7",
    fill: "none",
    stroke: "#5e5e5e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }))))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_382",
    "data-name": "Group 382"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_381",
    "data-name": "Group 381"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_380",
    "data-name": "Group 380"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_379",
    "data-name": "Group 379"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M167.057,301.3l-32.986.223a1.269,1.269,0,0,1-1.295-1.27l.009-.951a1.318,1.318,0,0,1,1.317-1.288l32.986-.223a1.268,1.268,0,0,1,1.294,1.27l-.008.952A1.316,1.316,0,0,1,167.057,301.3Z",
    fill: "#f6f7f7",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_386",
    "data-name": "Group 386"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_385",
    "data-name": "Group 385"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_384",
    "data-name": "Group 384"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_383",
    "data-name": "Group 383"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M134.519,287.357l-1.265,9.767c-.156,1.2.522,2.292,1.425,2.286l31.368-.212a2.331,2.331,0,0,0,2.061-1.448c.447-.963.548-2.41-.839-4.345-2.775-3.87-11.994-4.756-16.478-8.045l-14.612.1A1.948,1.948,0,0,0,134.519,287.357Z",
    fill: "#f6f7f7"
  })))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_391",
    "data-name": "Group 391"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_390",
    "data-name": "Group 390"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_389",
    "data-name": "Group 389"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_388",
    "data-name": "Group 388"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_387",
    "data-name": "Group 387"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    d: "M148.523,291.042h0a.643.643,0,0,1-.171-.794c.627-1.341,2.581-4.61,6.492-3.968a.54.54,0,0,1,.336.635l0,.01c-.04.294-.245.488-.464.453-3.505-.564-5.167,2.317-5.675,3.441A.362.362,0,0,1,148.523,291.042Z",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }))))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_396",
    "data-name": "Group 396"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_395",
    "data-name": "Group 395"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_394",
    "data-name": "Group 394"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_393",
    "data-name": "Group 393"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_392",
    "data-name": "Group 392"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    "data-name": "Path 539",
    d: "M151.77,292.276h0a.645.645,0,0,1-.172-.794c.628-1.341,2.582-4.61,6.493-3.968a.54.54,0,0,1,.336.635l0,.01c-.04.294-.245.488-.464.453-3.505-.563-5.167,2.317-5.675,3.441A.362.362,0,0,1,151.77,292.276Z",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }))))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_401",
    "data-name": "Group 401"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_400",
    "data-name": "Group 400"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_399",
    "data-name": "Group 399"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_398",
    "data-name": "Group 398"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_397",
    "data-name": "Group 397"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    d: "M154.789,293.428h0a.645.645,0,0,1-.171-.794c.628-1.342,2.581-4.61,6.493-3.968.226.037.376.331.335.635v.009c-.04.294-.246.488-.464.453-3.506-.563-5.168,2.318-5.676,3.442A.362.362,0,0,1,154.789,293.428Z",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_410",
    "data-name": "Group 410",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_405",
    "data-name": "Group 405"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_404",
    "data-name": "Group 404"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_403",
    "data-name": "Group 403"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_402",
    "data-name": "Group 402"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    d: "M143.051,299.354c-2.4-7.868-6.655-8.71-8.983-8.512l-.814,6.282c-.156,1.2.522,2.292,1.425,2.286Z",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_409",
    "data-name": "Group 409"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_408",
    "data-name": "Group 408"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_407",
    "data-name": "Group 407"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_406",
    "data-name": "Group 406"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M134.671,299.582a1.408,1.408,0,0,1-1.053-.508,2.514,2.514,0,0,1-.534-1.972l.831-6.42.138-.011c2.376-.206,6.725.651,9.162,8.632l.067.221-8.6.058ZM134.22,291l-.795,6.143a2.19,2.19,0,0,0,.451,1.7,1.066,1.066,0,0,0,.795.392h.007l8.14-.055C140.488,291.789,136.5,290.853,134.22,291Z",
    fill: "#101010",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }))))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_414",
    "data-name": "Group 414"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_413",
    "data-name": "Group 413"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_412",
    "data-name": "Group 412"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_411",
    "data-name": "Group 411"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M149.055,302.108l-32.987.223a1.269,1.269,0,0,1-1.294-1.27l.008-.952a1.318,1.318,0,0,1,1.317-1.288l32.986-.223a1.269,1.269,0,0,1,1.295,1.27l-.009.952A1.317,1.317,0,0,1,149.055,302.108Z",
    fill: "#f6f7f7",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })))))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_418",
    "data-name": "Group 418"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_417",
    "data-name": "Group 417"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_416",
    "data-name": "Group 416"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_415",
    "data-name": "Group 415"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    d: "M116.517,288.159l-1.265,9.767c-.156,1.2.522,2.292,1.424,2.287L148.045,300a2.328,2.328,0,0,0,2.061-1.448c.447-.963.547-2.41-.84-4.345-2.774-3.87-11.993-4.756-16.477-8.045l-14.612.1A1.948,1.948,0,0,0,116.517,288.159Z",
    fill: "#f6f7f7"
  })))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_423",
    "data-name": "Group 423"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_422",
    "data-name": "Group 422"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_421",
    "data-name": "Group 421"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_420",
    "data-name": "Group 420"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_419",
    "data-name": "Group 419"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    d: "M130.991,291.468h0a.645.645,0,0,1-.172-.794c.628-1.341,2.582-4.61,6.493-3.968a.54.54,0,0,1,.336.635l0,.01c-.04.294-.245.488-.464.453-3.505-.564-5.167,2.317-5.675,3.441A.362.362,0,0,1,130.991,291.468Z",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }))))))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_428",
    "data-name": "Group 428"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_427",
    "data-name": "Group 427"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_426",
    "data-name": "Group 426"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_425",
    "data-name": "Group 425"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_424",
    "data-name": "Group 424"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M133.767,293.078h0a.644.644,0,0,1-.171-.794c.628-1.341,2.581-4.609,6.493-3.967.226.037.376.33.335.634v.01c-.04.294-.246.488-.464.453-3.506-.563-5.168,2.317-5.676,3.441A.361.361,0,0,1,133.767,293.078Z",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }))))))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_433",
    "data-name": "Group 433"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_432",
    "data-name": "Group 432"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_431",
    "data-name": "Group 431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_430",
    "data-name": "Group 430"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_429",
    "data-name": "Group 429"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    d: "M136.787,294.23h0a.643.643,0,0,1-.171-.794c.627-1.342,2.581-4.61,6.492-3.968.226.037.377.331.336.635l0,.009c-.039.3-.245.488-.464.453-3.5-.562-5.167,2.318-5.675,3.442A.362.362,0,0,1,136.787,294.23Z",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }))))))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Group_436",
    "data-name": "Group 436"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_435",
    "data-name": "Group 435"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_434",
    "data-name": "Group 434"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    d: "M161.469,115.906l4.883,51.258s-1.3,2.792,7.332,2.341c14.04-.732,21.876-.24,5.017-3.168l-3.666-.9,6.721-53.238Z",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }))))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Group_440",
    "data-name": "Group 440"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_439",
    "data-name": "Group 439"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_438",
    "data-name": "Group 438"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_437",
    "data-name": "Group 437"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_36",
    "data-name": "Line 36",
    y1: 13.17,
    x2: 5.077,
    transform: "translate(161.469 96.898)",
    fill: "none",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })))))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Group_444",
    "data-name": "Group 444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_443",
    "data-name": "Group 443"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_442",
    "data-name": "Group 442"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_441",
    "data-name": "Group 441"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    d: "M180.245,124.642c-10.516,6.4-38.465,15.358-45.757,11.445s-8.262-23.426-8.262-23.426l22.668-1.828s-.534,8.892,2.245,9.781,25.874-4.712,25.874-4.712l.93-.306,4.082-1.474c.113-.041.077-.426.08-.509a1.211,1.211,0,0,1,.155-.644,14.991,14.991,0,0,1,1.067-1.636,6.033,6.033,0,0,0,1.519-2.982,2.749,2.749,0,0,0-.411-1.544,5.325,5.325,0,0,1-.559-.982,1.028,1.028,0,0,1,.242-1.092,1.416,1.416,0,0,1,.744-.316,2.366,2.366,0,0,1,2.154.862,4.1,4.1,0,0,1,.757,2.075,7.186,7.186,0,0,0,.4,1.744,1.955,1.955,0,0,0,1.813,1.324l1.771-.64,1.089-.393a1.566,1.566,0,0,1,2.012.847,1.514,1.514,0,0,1-.952,1.918l.355-.128a1.482,1.482,0,1,1,1.006,2.785l-.188.068a1.483,1.483,0,1,1,1.007,2.786l-.058.02-.409.148a1.046,1.046,0,1,1,.71,1.966l-.842.3q-3.591,1.3-7.18,2.6c-.584.212-1.486.732-2.122.57a2.961,2.961,0,0,1-.551-.263c-.808-.4-1.824.223-2.616.509l-1.952.706Z",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })))))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Group_448",
    "data-name": "Group 448"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_447",
    "data-name": "Group 447"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_446",
    "data-name": "Group 446"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_445",
    "data-name": "Group 445"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M128.68,90.977s-2.561,15.509-2.561,21.916l22.977-1.917,2.006-18.22",
    fill: "#043aaa",
    stroke: "#5e5e5e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M165.941,52.943a40.554,40.554,0,0,0-2.495,8.2,7.618,7.618,0,0,0,1.143,5.543l.194.3a5.961,5.961,0,0,0,5.143,2.68h0a7.591,7.591,0,0,0,5.454-2.5,59.993,59.993,0,0,0,5.065-6.866s5.94-8.316-2.664-12.443C169.207,43.747,165.941,52.943,165.941,52.943Z",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M165.967,58l-.044.088a1.825,1.825,0,0,1-2.477.827l-.013-.007.069-1.577a16.99,16.99,0,0,1,.157-2.183c.3-2.916.078-4.278,1.044-6.2,2.559-5.094,5.4-3.259,5.4-3.259a3.236,3.236,0,0,1,.346-.394c6.173-6.993,12.055-3.365,15.513.5a10.7,10.7,0,0,1,1.351,1.672c.311.427.587.838.823,1.215,2.62,4.2,4.7,4.047,4.7,4.047a3.369,3.369,0,0,1-2.18.509c2.241,1.126,3.3-.346,3.3-.346-.455,3.461-4.494,4.968-6,4.444a5.939,5.939,0,0,0,2.5,1.255s-7.381,4.473-18.2-7.42a8.1,8.1,0,0,1-4.426,3.105l-1.73,3.454",
    fill: "#8c8c8c"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Table"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_451",
    "data-name": "Group 451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_450",
    "data-name": "Group 450"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_449",
    "data-name": "Group 449"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    width: 9.217,
    height: 127.277,
    transform: "translate(87.117 175.838)",
    fill: "#f6f7f7",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_454",
    "data-name": "Group 454"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_453",
    "data-name": "Group 453"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_452",
    "data-name": "Group 452"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_85",
    "data-name": "Rectangle 85",
    width: 9.217,
    height: 128.637,
    transform: "translate(283.527 174.479)",
    fill: "#f6f7f7",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_457",
    "data-name": "Group 457"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_456",
    "data-name": "Group 456"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_455",
    "data-name": "Group 455"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M317.644,178.814H60.653a3.655,3.655,0,0,1-3.386-3.874v-2.48a3.654,3.654,0,0,1,3.386-3.874H317.644a3.654,3.654,0,0,1,3.386,3.874v2.48A3.655,3.655,0,0,1,317.644,178.814Z",
    fill: "#f6f7f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_460",
    "data-name": "Group 460"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_459",
    "data-name": "Group 459"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_458",
    "data-name": "Group 458"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M276.152,168.586h41.492a3.654,3.654,0,0,1,3.386,3.874v2.48a3.655,3.655,0,0,1-3.386,3.874H230.082",
    fill: "#f6f7f7",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_37",
    "data-name": "Line 37",
    x2: 113.807,
    transform: "translate(103.047 168.586)",
    fill: "#f6f7f7",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M83.972,178.814H60.653a3.655,3.655,0,0,1-3.386-3.874v-2.48a3.654,3.654,0,0,1,3.386-3.874",
    fill: "none",
    stroke: "#5e5e5e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_38",
    "data-name": "Line 38",
    x1: 59.882,
    transform: "translate(107.025 178.814)",
    fill: "#f6f7f7",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_463",
    "data-name": "Group 463"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_462",
    "data-name": "Group 462"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_461",
    "data-name": "Group 461"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M99.421,304.4H83.92a1.466,1.466,0,0,1-1.466-1.467v-1.058a6.128,6.128,0,0,1,6.128-6.128H94.76a6.129,6.129,0,0,1,6.128,6.128v1.058A1.467,1.467,0,0,1,99.421,304.4Z",
    fill: "#f6f7f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_466",
    "data-name": "Group 466"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_465",
    "data-name": "Group 465"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_464",
    "data-name": "Group 464"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M295.886,304.4h-15.5a1.466,1.466,0,0,1-1.466-1.467v-1.058a6.128,6.128,0,0,1,6.128-6.128h6.178a6.129,6.129,0,0,1,6.128,6.128v1.058A1.467,1.467,0,0,1,295.886,304.4Z",
    fill: "#f6f7f7"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeFinish);
export default __webpack_public_path__ + "static/media/office-finish.a5397df9b8de709b8ba7772ebdbfc042.svg";
export { ForwardRef as ReactComponent };